import React, { useState } from "react";
import NOTAM from "./views/NOTAM";
import ATS from "./views/ATS";
import TFC from "./views/TFC";

const ContentPage2 = () => {
  const [activeTab, setActiveTab] = useState("ATS");
  const [iframeSrc, setIframeSrc] = useState("https://www.ais.fi/aipsup/AipSup.htm");

  const handleBackClick = () => {
    // Append a unique query parameter to force the iframe to reload
    setIframeSrc("https://www.ais.fi/aipsup/AipSup.htm?reload=" + new Date().getTime());
  };

  return (
    <div className="h-full overflow-hidden">
      <nav className="bg-gray-600 p-1 pl-2 flex justify-between items-center">
        <h1 className="text-white text-xs font-normal">INFO</h1>
        <div>
          {[
            { label: "ATS", tab: "ATS" },
            { label: "TFC", tab: "TFC" },
            { label: "NOTAM", tab: "NOTAM" },
            { label: "SUP", tab: "SUP" }
          ].map(({ label, tab }) => (
            <button
              key={label}
              className={`p-1 text-xs mr-1 ${activeTab === tab ? "bg-gray-700" : "bg-gray-800"} text-white`}
              onClick={() => setActiveTab(tab)}
            >
              {label}
            </button>
          ))}
        </div>
      </nav>

      <div className="bg-gray-300 p-2 pt-1 pr-1 absolute right-0 top-[30px] pb-8 h-full w-full">
        {activeTab === "NOTAM" ? (
            <NOTAM />
        ) : activeTab === "ATS" ? (
            <ATS />
        ) : activeTab === "TFC" ? (
            <TFC />
        ) : (
          <div className="w-full h-full overflow-hidden">
            <div className="absolute top-0 left-0 pl-1 pr-1 pb-1 z-10 bg-gray-600">
              <button
                className="text-white text-xs p-1 bg-gray-700"
                onClick={handleBackClick}
              >
                Main Page
              </button>
            </div>
            <iframe
              src={iframeSrc}
              title="SUP"
              className="border-none absolute top-0 left-0"
              style={{
                width: "100%",
                height: "100%",
              }}
            ></iframe>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContentPage2;
